module.exports = () => ({
  restrict: 'A',
  scope: {
    multilineEllipsis: '<',
    maxLines: '@',
  },
  controllerAs: 'multilineEllipsisCtrl',
  controller: class MultilineEllipsisController {
    static $inject = [
      '$scope',
      '$element',
      '$timeout',
      '$window',
    ];

    options = {
      supportsNativeClamp: false,
      avgCharWidth: 7,
    };

    constructor(
      $scope,
      $element,
      $timeout,
      $window,
    ) {
      this.$scope = $scope;
      this.$element = $element;
      this.$timeout = $timeout;
      this.$window = $window;
    }

    $onInit() {
      this.$scope.showFullText = false;
      this.$scope.isTextWrapped = true;
      this.$scope.wrappedText = null;

      this.options.supportsNativeClamp = typeof (this.$element.css('webkitLineClamp')) !== 'undefined';

      if (this.options.supportsNativeClamp) {
        this.$scope.wrappedText = this.$scope.multilineEllipsis;
        this.options.clampedElement = this.$element.find('.clamped-text');
        this.options.clampedElement.css({ webkitLineClamp: this.$scope.maxLines });

        this.throttledCheckForOverflow = _.throttle(this.checkForOverflow, 100);

        // Wait on next frame
        this.$timeout(this.throttledCheckForOverflow);

        angular.element(this.$window).on('resize', this.throttledCheckForOverflow);

        this.$scope.$on('$destroy', () => {
          angular.element(this.$window).off('resize', this.throttledCheckForOverflow); // remove the handler added earlier
        });
      } else {
        this.throttledTruncate = _.throttle(this.truncate, 100);

        // Wait on next frame
        this.$timeout(this.throttledTruncate);

        angular.element(this.$window).on('resize', this.throttledTruncate);

        this.$scope.$on('$destroy', () => {
          angular.element(this.$window).off('resize', this.throttledTruncate); // remove the handler added earlier
        });
      }
    }

    toggleAdditionalInfoFullDisplay() {
      this.$scope.showFullText = !this.$scope.showFullText;

      if (this.options.supportsNativeClamp) {
        // Wait on next frame
        this.$timeout(this.throttledCheckForOverflow);
      } else {
        this.throttledTruncate();
      }
    }

    // Check if ellipsis is applied
    checkForOverflow = () => {
      const overflowing = this.options.clampedElement[0].clientWidth < this.options.clampedElement[0].scrollWidth
        || this.options.clampedElement[0].clientHeight < this.options.clampedElement[0].scrollHeight;
      this.$scope.isTextWrapped = overflowing || this.$scope.showFullText;
      this.$scope.$digest();
    }

    truncate = () => {
      this.$scope.isTextWrapped = false;

      if (!this.$scope.showFullText) {
        const nbCharsDisplayed = (this.$element.width() / this.options.avgCharWidth) * this.$scope.maxLines;
        this.$scope.wrappedText = this.$scope.multilineEllipsis.substr(0, nbCharsDisplayed);
        if (this.$scope.wrappedText !== this.$scope.multilineEllipsis) {
          this.$scope.isTextWrapped = true;
          this.$scope.wrappedText = `${this.$scope.wrappedText}...`;
        }
      } else {
        this.$scope.isTextWrapped = true;
      }
      this.$scope.$digest();
    };
  },
  template: `
    <span ng-hide="showFullText" class="clamped-text" ng-bind="wrappedText"></span>
    <span ng-show="showFullText" ng-bind="multilineEllipsis"></span>
    <button type="button" class="toggle-full-display" ng-click="multilineEllipsisCtrl.toggleAdditionalInfoFullDisplay()" ng-show="isTextWrapped"
            translate="{{ showFullText ? 'home.upcoming.additional_info.show_less' : 'home.upcoming.additional_info.details' }}"
            ng-class="{ '-show-less': showFullText, '-show-more': !showFullText }"></button>
  `,
});



// WEBPACK FOOTER //
// ./main/directives/multiline-ellipsis.js